/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Core owns the internal shared document validation scope.
 */
import { createContext } from 'react';

/** Internal coordination: inactive FormBuilder panels must participate in validation. */
export const DocumentValidationContext = createContext(false);
